import React from 'react';
import { TwoSidedScoreCard } from './TwoSidedScoreCard';
import { ScoreCard } from './ScoreCard';
import { title } from '../AdvancedStats/translations';
import { round2Display } from '../../lib/format';

export const ShootingProfileSummary = ({ totals }) => {
  const teamCalculated = totals.team.calculated;
  const oppCalculated = totals.opponent.calculated;

  const percentageFields = [
    'atr_percentage',
    'mid_percentage',
    'three_percentage',
  ];
  const rateFields = ['atr_rate', 'mid_rate', 'three_rate'];
  const atrAvailable =
    teamCalculated.atr_percentage && teamCalculated.atr_percentage !== null;
  const pps = {
    team: {
      atr: teamCalculated.atr_percentage * 2,
      mid: teamCalculated.mid_percentage * 2,
      three: teamCalculated.three_percentage * 3,
      noft: teamCalculated.pps_noft,
      all: teamCalculated.pps,
    },
    opp: {
      atr: oppCalculated.atr_percentage * 2,
      mid: oppCalculated.mid_percentage * 2,
      three: oppCalculated.three_percentage * 3,
      noft: oppCalculated.pps_noft,
      all: oppCalculated.pps,
    },
  };

  const cards = fields =>
    fields.map(stat => {
      const teamStat = teamCalculated[stat];
      const oppStat = oppCalculated[stat];
      const netValue = teamStat - oppStat;

      return (
        <div className="s-lineup-explorer__score" key={stat}>
          <TwoSidedScoreCard
            title={title(stat)}
            value={teamStat}
            oppValue={oppStat}
            netValue={netValue}
          />
        </div>
      );
    });

  if (!atrAvailable) {
    return (
      <div className="s-lineup-explorer__data-container">
        <div className="s-lineup-explorer__incomplete-source">
          Shooting Profile for current selection unavailable due to incomplete
          source data.
        </div>
      </div>
    );
  }

  return (
    <div className="s-lineup-explorer__data-container">
      <h3 className="s-lineup-explorer__metrics-header">
        Shooting Profile - All Lineups
      </h3>
      <div className="s-lineup-explorer__scores-container">
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="PPS - Rim"
            value={pps.team.atr}
            color="#417505"
            formatter={round2Display}
          />
        </div>
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="PPS - Mid"
            value={pps.team.mid}
            color="#417505"
            formatter={round2Display}
          />
        </div>
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="PPS - Three"
            value={pps.team.three}
            color="#417505"
            formatter={round2Display}
          />
        </div>
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="PPS - Overall"
            value={pps.team.noft}
            color="#417505"
            formatter={round2Display}
          />
        </div>
      </div>
      <div className="s-lineup-explorer__scores-container">
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="Opp PPS - Rim"
            value={pps.opp.atr}
            color="#417505"
            formatter={round2Display}
          />
        </div>
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="Opp PPS - Mid"
            value={pps.opp.mid}
            color="#417505"
            formatter={round2Display}
          />
        </div>
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="Opp PPS - Three"
            value={pps.opp.three}
            color="#417505"
            formatter={round2Display}
          />
        </div>
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="Opp PPS - Overall"
            value={pps.opp.noft}
            color="#417505"
            formatter={round2Display}
          />
        </div>
      </div>
      <div className="s-lineup-explorer__scores-container">
        {atrAvailable ? (
          cards(percentageFields)
        ) : (
          <div className="s-lineup-explorer__scores-container__unavailable-data">
            Shooting Profile unavailable due to incomplete source data.
          </div>
        )}
      </div>
      <div className="s-lineup-explorer__scores-container">
        {atrAvailable ? cards(rateFields) : <div></div>}
      </div>
    </div>
  );
};
